import { render, staticRenderFns } from "./uploader.vue?vue&type=template&id=13dcf5f2&scoped=true"
import script from "./uploader.vue?vue&type=script&lang=js"
export * from "./uploader.vue?vue&type=script&lang=js"
import style0 from "./uploader.vue?vue&type=style&index=0&id=13dcf5f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13dcf5f2",
  null
  
)

export default component.exports